/**
 * Address Lookup
 *
 * @author Deepak
 *
 */
$(document).ready(function() {
  var __addressData = [];
  var __lookupKey = 'lookupIndex-';
  var __formType;

  var postcodeFormField = $('input[name="postcode"], input[name="billingAddress.postcode"]');
  postcodeFormField.on('blur change', function() {
    var postcode = postcodeFormField.val().toUpperCase();
    postcodeFormField.val(postcode);
  });
  postcodeFormField.on('focus', function() {
    $('.address-lookup-trigger').removeAttr('disabled');
    $('.address-lookup-error').addClass('hide');
    $('.address-lookup-success').addClass('hide');
    $('.lookup-suggestions').removeClass('active');
    $('#postcode\\.errors').addClass('hide');
  });

  // NOTE : Implementation using lookup key index to avoid re-parsing of JSON object to string and vice verse).

  // Bind lookup api trigger

  $('.address-lookup-trigger').on('click', function(event) {
    event.preventDefault();

    var $buttonRef = $(this);
    $buttonRef.attr('disabled', true);
    var $buttonMessage = $buttonRef.find('span').last();
    var api_endpoint = $(this).attr('data-api-endpoint');
    var api_processing_msg = $(this).attr('data-api-process-message');
    var postcodeFieldName = $(this).attr('data-api-postcode-field-name');
    __formType = $(this).attr('data-api-form-type');
    var formField = $('input[name="' + postcodeFieldName + '"]');
    var postcode = formField
      .val()
      .toUpperCase()
      .replace(/^\s+|\s+$/gm, '');
    formField.val(postcode);
    var originalText = $buttonMessage.text();
    var serverSideErrorMessage = $('.form__item--error').find("span[id='postcode.errors']");
    serverSideErrorMessage.hide(0, function() {
      serverSideErrorMessage
        .closest('div.form__item--error')
        .removeClass('form__item--error')
        .removeClass('alert-icon-after')
        .addClass('form-group')
        .addClass('required');
    });

    $buttonRef.addClass('searching');
    $buttonMessage.text(api_processing_msg); // Change button message

    $.ajax({
      url: api_endpoint,
      method: 'POST',
      data: {
        payload: encodeURIComponent(postcode),
      },
      success: function(response, status, jqXHR) {
        $buttonRef.removeAttr('disabled');
        let data = $.parseJSON(response.data);
        if (!$.isEmptyObject(data)) {
          $('.address-lookup-error').addClass('hide');
          $('.address-lookup-success').removeClass('hide');
          $('.address-lookup-target-container').removeClass('hide');
          populateAddressSuggestions(data);
          $('.lookup-suggestions').addClass('active');
          __addressData = data;
        } else {
          $('.address-lookup-error').removeClass('hide');
          $('.address-lookup-success').addClass('hide');
          $('.address-lookup-target-container').addClass('hide');
          $('.lookup-suggestions').removeClass('active');
        }
      },
      error: function(response, status, jqXHR) {
        $('.address-lookup-error').removeClass('hide');
        $('.address-lookup-success').addClass('hide');
        $('.address-lookup-target-container').addClass('hide');
        $('.lookup-suggestions').removeClass('active');
      },
    }).done(function(data) {
      setTimeout(function() {
        $buttonRef.removeClass('searching');
        $buttonMessage.text(originalText);
      }, 500);
    });
  });

  // Bind lookup api target
  $('.address-lookup-target').on('change', function(event) {
    var optionSelected = $('option:selected', this);
    var valueSelected = this.value;
    var optionSelectedText = $(this).text();
    $.each(__addressData, function(key, value) {
      if (__lookupKey + key == valueSelected) {
        populateAddressFormFields(__formType, value);
      }
    });
    $('.lookup-suggestions').removeClass('active');
  });

  // Populate select list of targets
  function populateAddressSuggestions(data) {
    if (!$.isEmptyObject(data)) {
      $('.address-lookup-target')
        .find('option:gt(0)')
        .remove(); // empty previous address options
      $('.address-lookup-target').val($('.address-lookup-target option:first').val());
      $.each(data, function(key, value) {
        $('.address-lookup-target').append(
          $('<option></option>')
            .val(__lookupKey + key)
            .html(computeAddressLines(value))
        );
      });
      $('.address-lookup-target option:first').trigger('change', function(event) {});
    }
  }

  // Parse response
  function computeAddressLines(obj) {
    var concatString = '';
    var seperator = ', ';
    if (!$.isEmptyObject(obj)) {
      if ('line1' in obj && obj.line1.length > 0) {
        concatString += obj.line1 + seperator;
      }
      if ('line2' in obj && obj.line2.length > 0) {
        concatString += obj.line2 + seperator;
      }
      if ('line3' in obj && obj.line3.length > 0) {
        concatString += obj.line3 + seperator;
      }
      if ('town' in obj && obj.town.length > 0) {
        concatString += obj.town + seperator;
      }
      if ('county' in obj && obj.county.length > 0) {
        concatString += obj.county + seperator;
      }
      if ('postcode' in obj && obj.postcode.length > 0) {
        concatString += obj.postcode;
      }
    }
    return concatString;
  }

  // Populate address form fields (based on form type)
  function populateAddressFormFields(formType, obj) {
    switch (formType) {
      case 'billing':
        clearBillingFormFields();
        populateBillingFormFields(obj);
        break;
      case 'shipping':
        clearShippingFormFields();
        populateShippingFormFields(obj);
        break;
      case 'account':
        clearShippingFormFields();
        populateShippingFormFields(obj);
        break;
      default:
        clearShippingFormFields();
        populateShippingFormFields(obj);
        break;
    }
  }

  // Populate fields on the billing address form
  function populateBillingFormFields(obj) {
    var line1 = $('input[name="billingAddress.line1"]'),
      line2 = $('input[name="billingAddress.line2"]'),
      line3 = $('input[name="billingAddress.line3"]'),
      town = $('input[name="billingAddress.townCity"]');

    if (!$.isEmptyObject(obj)) {
      if ('line1' in obj && obj.line1.length > 0) {
        line1.val(obj.line1);
      } else {
        line1.val('');
      }
      if ('line2' in obj && obj.line2.length > 0) {
        line2.val(obj.line2);
      } else {
        line2.val('');
      }
      if ('line3' in obj && obj.line3.length > 0) {
        line3.val(obj.line3);
      } else {
        line3.val('');
      }
      if ('town' in obj && obj.town.length > 0) {
        town.val(obj.town);
      } else {
        town.val('');
      }
      setCounty(obj, 'billingAddress.regionIso', 'select_bill_to_address_state');
    }
  }

  function setCounty(obj, name, selectId) {
    var setCounty = false;
    if ('county' in obj && obj.county.length > 0) {
      var $select = $('select[name="' + name + '"]');
      var $option = $select.find('option:contains("' + obj.county + '")');
      if ($option.length > 0) {
        $option.prop('selected', true);
        $('#' + selectId).text(obj.county);
        setCounty = true;
      }
    }
    if (!setCounty) {
      var $naOption = $select.find('option:nth-child(2)');
      $naOption.attr('selected', 'selected');
      $('#' + selectId).text($naOption.text());
    }
  }

  // Populate fields on the shipping address form
  function populateShippingFormFields(obj) {
    var line1 = $('input[name="line1"]'),
      line2 = $('input[name="line2"]'),
      line3 = $('input[name="line3"]'),
      town = $('input[name="townCity"]');

    if (!$.isEmptyObject(obj)) {
      if ('line1' in obj && obj.line1.length > 0) {
        line1.val(obj.line1);
      } else {
        line1.val('');
      }
      if ('line2' in obj && obj.line2.length > 0) {
        line2.val(obj.line2);
      } else {
        line2.val('');
      }
      if ('line3' in obj && obj.line3.length > 0) {
        line3.val(obj.line3);
      } else {
        line3.val('');
      }
      if ('town' in obj && obj.town.length > 0) {
        town.val(obj.town);
      } else {
        town.val('');
      }
      setCounty(obj, 'regionIso', 'select_regionIso');
    }
  }

  // Clear shipping form fields
  function clearShippingFormFields() {
    $('select[name="regionIso"]').val($('select[name="regionIso"] option:first').val());
    $('select[name="regionIso"] option:first').trigger('change', function(event) {});
  }

  // Clear billing form fields
  function clearBillingFormFields() {
    $('select[name="billingAddress.state"]').val($('select[name="billingAddress.state"] option:first').val());
    $('select[name="billingAddress.state"] option:first').trigger('change', function(event) {});
  }
});
